// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1HoOn","head":"ProcedureTableInfo_head__2v4Iv"};